export enum RugbyLeagueTryAttribute {
  Golden = 2989,
}
